/**
 * Read the device's *current* push subscription, read-only — never creates one.
 * Resolves to `null` when the browser has no PushManager or no active subscription.
 *
 * Shared by the callers that only need to observe the existing subscription (the
 * footer's endpoint display, the opt-in re-registration) without triggering a
 * `subscribe()`. The boot-time registration path keeps its own create/refresh
 * logic (VAPID-key validation, resubscribe) in `use-device-registration`.
 */
export const getCurrentPushSubscription = async (): Promise<PushSubscription | null> => {
  const registration = await navigator.serviceWorker.ready;
  if (!("PushManager" in window)) return null;
  return registration.pushManager.getSubscription();
};
